/* eslint-disable @typescript-eslint/no-empty-function */
import { palette } from "lib/miolo";
import ContentSectionDescriptionLine from "components/company/sections/ContentSectionDescriptionLine";
import ContentSectionHeading from "components/company/sections/ContentSectionHeading";
import StaticContentSection from "components/company/StaticContentSection";

import type { IBrazilianCompanyIssuerTopLevelFragment } from "lib/fragments/__generated__/BrazilianCompanyIssuerTopLevel.generated";

interface IKeyCustomersSectionProps {
  keyCustomers: NonNullable<IBrazilianCompanyIssuerTopLevelFragment["keyCustomers"]>;
}

export default function KeyCustomersSection({ keyCustomers }: IKeyCustomersSectionProps) {
  return (
    <div>
      <StaticContentSection primaryColor={palette.fiord} css={{ rowGap: 12 }}>
        <div css={{ gridColumn: "span 12" }}>
          <ContentSectionHeading>Principais Clientes</ContentSectionHeading>

          <ContentSectionDescriptionLine>
            Confira se algum cliente foi responsável por pelo menos 10% da Receita Líquida total.
          </ContentSectionDescriptionLine>
        </div>

        <div css={{ gridColumn: "span 12" }}>
          <p
            css={{
              margin: 0,
              padding: 16,
              color: palette.blueBayoux,
              fontWeight: 500,
              fontSize: 16,
              lineHeight: 1.33,
              backgroundColor: palette.catskillWhite,
              borderRadius: 4,
            }}
          >
            {keyCustomers.description}
          </p>
        </div>

        <div css={{ gridColumn: "span 12" }}>
          <span
            css={{
              fontSize: 14,
              fontWeight: 500,
              color: palette.lynch,
              fontFamily: "museo-sans-condensed",
              letterSpacing: 1,
            }}
          >
            Ano de Referência: <strong>{keyCustomers.yearOfReference}</strong>
          </span>
        </div>
      </StaticContentSection>
    </div>
  );
}
